'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBSUB_READY = exports.INITIALIZE_PUBSUB = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var INITIALIZE_PUBSUB = exports.INITIALIZE_PUBSUB = (0, _createAsyncActionTypes.createAsyncActionTypes)('INITIALIZE_PUBSUB');

var PUBSUB_READY = exports.PUBSUB_READY = 'PUBSUB_READY';